import { SearchOutlined } from '@ant-design/icons'
import { Input } from 'antd';
import './Search.less';
import React, { useState, useEffect } from 'react';
import api from "@/net/api";
import util from '@/util'

export default function PageTitle(props) {
	const [params, setParams] = useState({
		name: null,
	})

	return <div className="pages_main_product_Search" >
		<div className="select_box">
			<Input
				className="search-input"
				bordered={false}
				allowClear={true}
				placeholder='请输入食材名称'
				onChange={(e) => {
					setParams({
						...params,
						name: e.target.value,
					})
				}}
			/>
		</div>
		<div className="serach_btn" onClick={() => {
			props?.submitSearch(params)
		}}>
			<SearchOutlined className="search_icon" />
		</div>
	</div>
}
